import { fn } from '@common/utils';
import UISafe = fn.UISafe;
import { template as ktemplate, GetAmountTemplate, UpdateGridOptions, GetGridDataSource } from '../../navkendo';
import { NavClientService } from '../../navdata/navdata';
import { DialogService } from '@services/dialogservice';
import { NavGridVisibility, IPageQueryConstraint, IPageMetaData } from '../../nav';

const FDDI_Order_Information_Page = "FDDI_Order_Information_Page";

/** Controller for Displaying OrderInformation */
export class CtrlWKFOrderInformation {
    static readonly Template = require('./orderinformation.html');
    static $inject = ["$scope", "NavClient", "DialogService", "OrderNo", "NavUrl"];
    constructor(
        $scope: ng.IScope,
        NavClient: NavClientService,
        DialogService: DialogService,
        orderNo: any,
        navUrl: string
    ) {
        if (!orderNo) {
            DialogService.ShowError("Fehlender Parameter : 'orderNo'");
            return;
        }

        function getColumns(metaData: IPageMetaData) {
            var displayProps = metaData.Properties.filter(item => item.Invisible !== true
                && item.GridVisibility !== NavGridVisibility.ForcedRemove);
            // Preserve column order
            return displayProps.map(pageProp => {
                var field = pageProp.Name,
                    propCol = metaData.GetColumn(pageProp);
                if (!propCol)
                    return;
                // Default col width
                propCol.width = "120px";

                // Apply templates
                switch (field) {
                    // Truncate field content
                    case "Kostenstelle_Name":
                    case "Kostenträger_Name":
                    case "Description":
                        propCol.template = ktemplate("<span class='idms_truncate' title='#= data." + field + " #'>#= data." + field + " ? data." + field + " : '' #</span>");
                        break;

                    case "QuantityInWF":
                        // Critical quantity template
                        propCol.template = GetAmountTemplate(field, propCol.format, "FormatQuantityCritical", "idms_BGColor_Error");
                        break;

                    case "AmountInWF":
                        // Critical amount template
                        propCol.template = GetAmountTemplate(field, propCol.format, "FormatAmountCritical", "idms_BGColor_Error");
                        break;
                    default:
                    // Nothing to do
                }
                return propCol;
            }).filter(fn.isSet);
        }

        function loadData() {
            return NavClient.ReadMultiple<"FDDI_Order_Information_Page">({
                PageName: FDDI_Order_Information_Page,
                Constraints: [<IPageQueryConstraint>{
                    FieldName: "Document_No",
                    Value: orderNo,
                    Op: "eq"
                }],
                PageCount: 0 // 0 : readall
            }, navUrl).then(d => d.Data);
        }

        // Close button action
        $scope["CloseCmd"] = (evt: JQueryMouseEventObject) => {
            var jqWnd = $(evt.target).closest(".k-window-content");
            var kWnd = <kendo.ui.Window>jqWnd.data("kendoWindow");
            if (kWnd) {
                kWnd.close();
            }
        };

        // Load Data, Fill GridOptions
        UISafe(NavClient.GetPageMetaData<"FDDI_Order_Information_Page">(FDDI_Order_Information_Page, navUrl).then(orderInfoMetaData => {
            return loadData().then(displayData => {
                var noOfDocs = parseInt(displayData[0] && ("" + displayData[0].NoOfDocs));
                if (noOfDocs >= 0) {
                    $scope["OrderInfo"] = "Derzeitige Anzahl der Belege im Rechnungsworkflow mit Bezug zu dieser Bestellung: "
                        + noOfDocs + " Beleg" + ((noOfDocs == 1) ? "" : "e");
                }

                // Set grid content
                var gridOptions = $scope["GridOptions"] = <kendo.ui.GridOptions>{
                    columns: getColumns(orderInfoMetaData),
                    dataSource: GetGridDataSource(displayData, orderInfoMetaData.Model),
                    resizable: true,
                    selectable: 'row'
                };
                UpdateGridOptions(gridOptions);
            });
        }));
    }
}
